<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
        offset-md="2"
        offset-sm="1"
        sm="10"
      >
        <v-container
          fluid
          pa-0
        >
          <v-row>
            <v-col cols="12" />
          </v-row>

          <v-row v-if="$vuetify.breakpoint.mdAndDown">
            <v-col cols="12">
              <v-tabs
                background-color="white"
                class="rounded"
                color="brand-primary"
                light
                show-arrows
                slider-color="brand-primary"
              >
                <v-tab
                  v-for="(item, i) in itemsFiltered"
                  :key="i"
                  :to="{name: item.to}"
                  class="brand-primary--text"
                >
                  <v-icon
                    v-if="item.icon"
                    class="mr-3 brand-primary--text text--lighten-3"
                    v-text="item.icon"
                  />

                  {{ item.text }}
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="$vuetify.breakpoint.lgAndUp"
              class="shrink"
            >
              <v-list
                nav
              >
                <v-list-item-group color="brand-primary">
                  <v-list-item
                    v-for="(item, i) in itemsFiltered"
                    :key="i"
                    :to="{name: item.to}"
                  >
                    <v-list-item-icon v-if="item.icon">
                      <v-icon v-text="item.icon" />
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title v-text="item.text" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-col>
              <router-view
                :page-content="$t(`Page.${$route.name}.Body`)"
                :page-title="$t(`Page.${$route.name}.Title`)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name      : 'Terms',
  components: {},
  directives: {},
  mixins    : [],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      items: [
        /*
      {
        text : this.$t('Page.PoliciesTerms.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesTerms'
      },
      {
        text : this.$t('Page.PoliciesPrivacy.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesPrivacy'
      },
      {
        text : this.$t('Page.PoliciesProcessing.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesProcessing'
      },
      {
        text : this.$t('Page.PoliciesSla.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesSla'
      },
      {
        text : this.$t('Page.PoliciesPromo.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesPromo'
      },
      {
        text : this.$t('Page.PoliciesCookies.Name'),
        icon : 'mdi-file-document',
        group: 'policies',
        to   : 'PoliciesCookies'
      }
         */
      ]
    }
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(item => item.group === this.$route?.meta?.group)
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>
</style>
